/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;



/*****************
 ** WEBPACK FOOTER
 ** ../~/lodash/_baseLt.js
 ** module id = 1573
 ** module chunks = 3
 **/